



























import Vue from "vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import iwBackOfficeActionReason from "@/myImmoweb/modal/BackOfficeActionReason.vue";

import { BackOfficeAction } from "@/shared/interfaces/BackOfficeAction.interface";
import { reactivateClassified } from "@/shared/scripts/BackOfficeApi";

import { mapActions } from "vuex";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({

    components: {
        iwButtonLoading: iwButtonLoading,
        iwBackOfficeActionReason: iwBackOfficeActionReason
    },

    data: function() {
        return {
            isLoading: false,
            backOfficeReactivate: {} as BackOfficeAction
        };
    },

    methods: {
        ...mapActions({
            closeMasqueradeModal: "ModalModule/closeMasqueradeModal"
        }),

        updateInfo: function(info: string) {
            this.backOfficeReactivate.info = info;
        },

        reactivateClassifiedCall: function() {
            this.isLoading = true;
            reactivateClassified(this.backOfficeReactivate).then(res => {
                this.isLoading = false;
                if (res.status === "ACTIVE") {
                    this.$emit("success");
                }
            }).catch(error => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                console.error(error);
                this.isLoading = false;
            });
        }
    }
});
